<div class="bg">
<div class="wrapper">
  <div class="home mt-2" routerLink="/" style="color:white ; " >
    <img src="../../../../assets/images/studenty.png" routerLink="/" /> Back to home
  </div>
  <div class="headline">
    <h1>FORGOT PASSWORD !</h1>
  </div>
  <form [formGroup]="forme" (ngSubmit)="sendEmail()">
    <div class="signup">
      <div class="form-group">
        <input type="email" class="form-control" placeholder="Your mail" formControlName="email" required/>
        <div class="alert alert-danger" *ngIf="forme.controls.email.invalid && forme.controls.email.touched" style="text-align: center; width: 500px; margin-left: 80px">
          Email is a Required Field !
        </div>
      </div>
      <div style="color: white ;">
        S'il S'agit du Problèmes, Vous pouvez Visitez le
        <a href="/home/login/aide">centre d'aide</a>
      </div>
      <br>
      <button  type="submit" class="btn"> {{ disable === "" ? "Reset Password" : "verifying..." }}</button>
      <div class="alert alert-primary" style=" width: 500px; margin-left: 75px; text-align: center; border-radius: 15px;">
        {{ msg }}
      </div>
      <div class="account-exist">
        Create New a account? <a href="home/Register">Signup</a>
      </div>
      <div class="account-exist"></div>
    </div>
</form>    
</div>
</div>
<br />
<br />
